import React from 'react';

export interface DrawerContentCardItem {
  label: string;
  value: React.ReactNode;
  hidden?: boolean;
}

export interface DrawerContentCardProps {
  title?: string;
  list: DrawerContentCardItem[];
}

/**
 * DrawerContentCard — renders key/value rows inside a bordered card.
 *
 * When `title` is provided, shows a section header above the rows.
 * Items with `hidden: true` are filtered out automatically.
 */
export const DrawerContentCard: React.FC<DrawerContentCardProps> = ({
  title,
  list,
}) => {
  const visibleItems = list.filter(item => !item.hidden);
  if (visibleItems.length === 0) return null;

  return (
    <div className="rounded-lg border border-gray-100 bg-gray-50/50">
      {title && (
        <div className="px-4 py-2.5 border-b border-gray-100">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            {title}
          </span>
        </div>
      )}
      <div className="px-4 divide-y divide-gray-100">
        {visibleItems.map((item, i) => (
          <div key={i} className="flex items-start justify-between gap-4 py-3">
            <span className="text-sm text-muted-foreground flex-shrink-0">{item.label}</span>
            <div className="min-w-0 flex-1 text-end text-sm font-medium text-gray-900 break-words">
              {item.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
